import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=cd40dffe&scoped=true"
import script from "./LanguageButton.vue?vue&type=script&lang=js"
export * from "./LanguageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd40dffe",
  null
  
)

export default component.exports